<template>
  <div>
    <slot name="label">
      <div
        :class="[
          'text-truncate',
          labelBold ? 'text-body-2 font-weight-medium black--text': 'text-caption secondary-darken--text',
          { 'label-disabled': disabled }
        ]"
      >
        {{ label }}
      </div>
    </slot>

    <v-select
      v-bind="$attrs"
      dense
      solo
      flat
      :outlined="outlined"
      append-icon="$arrow-down"
      :background-color="backgroundColor"
      :items="items"
      :height="height"
      clear-icon="$close"
      :disabled="disabled"
      :error-messages="errorMessages"
      :menu-props="propsForMenu"
      v-on="$listeners"
    >
      <template v-if="itemSlot" #item="{ item, on }">
        <slot name="item" :item="item" :on="on" />
      </template>
      <template v-if="selectionSlot" #selection="{ item, index}">
        <slot name="selection" :item="item" :index="index" />
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner" />
      </template>
    </v-select>
  </div>
</template>

<script>
  export default {
    name: 'CSelect',
    inheritAttrs: false,
    props: {
      items: {
        type: Array,
        default: () => []
      },
      height: {
        type: [Number, String],
        default: '42px'
      },
      itemSlot: Boolean,
      selectionSlot: Boolean,
      label: {
        type: String,
        default: undefined
      },
      backgroundColor: {
        type: String,
        default: 'secondary-lighten'
      },
      labelBold: {
        type: Boolean,
        default: false
      },
      errorMessages: {
        type: [Array, String],
        default: ''
      },
      outlined: {
        type: Boolean,
        default: true
      },
      menuProps: {
        type: Object,
        default: () => ({})
      },
      borderColor: {
        type: String,
        default: 'transparent'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      disabledOpacity: {
        type: [Number, String],
        default: '0.5'
      }
    },
    computed: {
      propsForMenu () {
        return {
          bottom: true,
          offsetY: true,
          margin: '30px',
          ...this.menuProps
        }
      },
      getBorderColor () {
        return this.borderColor === 'transparent' ? 'transparent' : `var(--v-${this.borderColor}-base)`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label-disabled {
    opacity: v-bind(disabledOpacity);
  }
  ::v-deep {
    .v-input {
      font-size: 14px;

      &:not(.error--text) {
        &.v-input--is-focused fieldset,
        &:hover fieldset {
          border-color: var(--v-primary-base);
        }
        fieldset {
          border-color: v-bind(getBorderColor);
          font-size: 14px;
        }
      }
      &.v-input--is-disabled {
        color: var(--v-black-base);
        opacity: v-bind(disabledOpacity);
      }
      .v-select__slot .v-input__icon--append.v-input__icon {
        height: 12px;
        width: 12px;
        min-width: 12px;
        max-width: 12px;

        .v-icon__component {
          color: var(--v-black-base)!important;
          height: 12px;
          width: 12px;
        }
      }
      .v-select__slot .v-input__append-inner .v-input__icon--clear.v-input__icon {
        min-height: 12px;
        max-height: 12px;
        min-width: 12px;
        max-width: 12px;

        .v-icon__component {
          color: var(--v-error-base)!important;
          height: 12px;
          width: 12px;
        }
      }
    }
    .v-text-field  {
      & > .v-input__control,
      & > .v-input__control > .v-input__slot {
        min-height: 0 !important;
      }
    }
  }
</style>

<!-- !!!  not scoped, because list items are global  !!! -->
<style lang="scss">
  .v-application .v-menu__content.menuable__content__active {
    margin: 2px 0;
  }
</style>
